import pdfMake from "pdfmake/build/pdfmake";
//import * as pdfFonts from "pdfmake/build/vfs_fonts";

import printjs from "print-js";

//pdfMake.vfs = pdfFonts.pdfMake.vfs;

/*pdfMake.fonts = {
  Roboto: {
    normal:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
    bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
    italics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
    bolditalics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
  },
};*/

const createPdf = async (props, output = "print") => {
  return new Promise((resolve, reject) => {
    try {
      const {
        /*pageSize = {
          width: 226.77,
          height: 500, //841.88,
        },*/
        // a string or { width: number, height: number }
        pageSize = "LETTER",

        // by default we use portrait, you can change it to landscape if you wish
        pageOrientation = "landscape",
        pageMargins = [40, 60, 40, 60],
        info = {
          title: "F001-000001",
          author: "maclode",
          subject: "ticket",
          keywords: "tck, sale",
        },
        styles = {
          header: {
            font: "Roboto",
            fontSize: 9,
            bold: true,
            alignment: "center",
          },
          tHeaderLabel: {
            font: "Roboto",
            fontSize: 8,
            alignment: "right",
          },
          tHeaderValue: {
            fontSize: 8,
            bold: true,
          },
          tProductsHeader: {
            fontSize: 8.5,
            bold: true,
          },
          tProductsBody: {
            fontSize: 8,
          },
          tTotals: {
            fontSize: 9,
            bold: true,
            alignment: "right",
          },
          tClientLabel: {
            fontSize: 8,
            alignment: "right",
          },
          tClientValue: {
            fontSize: 8,
            bold: true,
          },
          text: {
            fontSize: 8,
            alignment: "center",
          },
          link: {
            fontSize: 9,
            bold: true,
            margin: [0, 0, 0, 4],
            alignment: "center",
          },
          link2: {
            fontSize: 9,
            bold: true,
            margin: [0, 0, 0, 4],
            alignment: "center",
          },
        },
        content,
      } = props;

      const docDefinition = {
        pageSize, //TAMAÑO HOJA
        pageOrientation,
        pageMargins, //MARGENES HOJA
        info, //METADATA PDF
        content, // CONTENIDO PDF
        styles, //ESTILOS PDF
      };

      if (output === "b64") {
        //SI INDICAMOS QUE LA SALIDA SERA [b64] Base64
        const pdfMakeCreatePdf = pdfMake.createPdf(docDefinition);
        pdfMakeCreatePdf.getBase64((data) => {
          resolve({
            success: true,
            content: data,
            message: "Archivo generado correctamente.",
          });
        });
        return;
      }

      //ENVIAR A IMPRESIÓN DIRECTA
      if (output === "print") {
        var docDefinition1 = {
          content: [
            "paragraph 1",
            "paragraph 2",
            {
              columns: [
                "first column is a simple text",
                [
                  // second column consists of paragraphs
                  "paragraph A",
                  "paragraph B",
                  "these paragraphs will be rendered one below another inside the column",
                ],
              ],
            },
          ],
        };

        var docDefinition2 = {
          content: [
            "paragraph 1",
            "paragraph 2",
            {
              columns: [
                "first column is a simple text",
                {
                  stack: [
                    // second column consists of paragraphs
                    "paragraph A",
                    "paragraph B",
                    "these paragraphs will be rendered one below another inside the column",
                  ],
                  fontSize: 15,
                },
              ],
            },
          ],
        };

        const pdfMakeCreatePdf = pdfMake.createPdf(docDefinition);
        pdfMakeCreatePdf.getBase64((data) => {
          printjs({
            printable: data,
            type: "pdf",
            base64: true,
          });
          resolve({
            success: true,
            content: null,
            message: "Documento enviado a impresión.",
          });
        });
        return;
      }

      reject({
        success: false,
        content: null,
        message: "Debes enviar tipo salida.",
      });
    } catch (error) {
      reject({
        success: false,
        content: null,
        message: error?.message ?? "No se pudo generar proceso.",
      });
    }
  });
};

export default createPdf;
